import React from 'react';
import AreaManagementRouter from './AreaManagementRouter';

export default function AreaManagementPage() {
  return <AreaManagementRouter />;
}
